(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["snip_blur_overlay"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const blurOverlay = document.querySelector('.blur-overlay');
    if (!blurOverlay) return;
    
    let ticking = false;
    
    function handleScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          updateBlurOpacity();
          ticking = false;
        });
        ticking = true;
      }
    }
    
    function updateBlurOpacity() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
      );

      // Calculate max scroll position
      const maxScroll = documentHeight - windowHeight;
      
      // Fade distance is 100px (same as blur overlay height)
      const fadeDistance = 100;
      
      // Calculate fade start point
      const fadeStartScroll = maxScroll - fadeDistance;
      
      let opacity = 1;
      
      if (scrollTop >= fadeStartScroll) {
        // Map scroll position from fadeStartScroll to maxScroll into opacity 1 to 0
        const progress = (scrollTop - fadeStartScroll) / fadeDistance;
        opacity = Math.max(0, 1 - progress);
      }
      document.querySelector('.blur-overlay-inner').style.setProperty('--blur-factor', opacity);
    }
    
    // Add scroll listener
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Initial check
    if ('requestIdleCallback' in window) {
      requestIdleCallback(updateBlurOpacity, { timeout: 2000 });
    } else {
      setTimeout(updateBlurOpacity, 1000);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snip_dossier_slider"] && !Shopify.designMode) return;
  try {
    (() => {
    const initSlider = (root) => {
      if (root.dataset.sliderReady) return;
      root.dataset.sliderReady = 'true';

      const track = root.querySelector('[data-slider-track]');
      const nav = root.querySelector('[data-slider-nav]');
      const prevs = [...root.querySelectorAll('[data-slider-prev]')];
      const nexts = [...root.querySelectorAll('[data-slider-next]')];
      const dots = [...root.querySelectorAll('[data-slider-dot]')];
      if (!track) return;

      const cards = () => [...track.children];
      const step = () => {
        const first = cards()[0];
        if (!first) return track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      };

      const update = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        const overflow = maxScroll > 2;
        if (nav) nav.hidden = !overflow;
        prevs.forEach((btn) => (btn.disabled = track.scrollLeft <= 2));
        nexts.forEach((btn) => (btn.disabled = track.scrollLeft >= maxScroll - 2));

        const active = Math.min(cards().length - 1, Math.round(track.scrollLeft / step()));
        const atEnd = track.scrollLeft >= maxScroll - 2;
        dots.forEach((dot, i) => dot.classList.toggle('is-active', atEnd ? i === dots.length - 1 : i === active));
      };

      prevs.forEach((btn) => btn.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' })));
      nexts.forEach((btn) => btn.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' })));
      dots.forEach((dot, i) => dot.addEventListener('click', () => track.scrollTo({ left: i * step(), behavior: 'smooth' })));

      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    };

    const initAll = () => document.querySelectorAll('[data-dossier-slider]').forEach(initSlider);
    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snip_policy_page"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-policy-page]');
    if (!root) return;

    // Phones: bring the current policy's pill into view in the sideways-scrolling list
    const navList = root.querySelector('.policy-page__nav-list');
    const activeLink = navList?.querySelector('.is-active');
    if (navList && activeLink && navList.scrollWidth > navList.clientWidth) {
      navList.scrollLeft = activeLink.offsetLeft - navList.offsetLeft - 16;
    }

    // "On this page": built from the policy's headings, only when there are enough to be useful
    const body = root.querySelector('.shopify-policy__body');
    const toc = root.querySelector('[data-policy-toc]');
    const list = root.querySelector('[data-policy-toc-list]');
    if (!body || !toc || !list) return;

    let headings = [...body.querySelectorAll('h1, h2')];
    if (headings.length < 3) headings = [...body.querySelectorAll('h1, h2, h3')];
    headings = headings.filter((heading) => heading.textContent.trim() && heading.offsetParent !== null);
    if (headings.length < 3) return;

    const links = headings.map((heading, index) => {
      if (!heading.id) heading.id = `policy-section-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.className = 'policy-page__toc-link';
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
      return link;
    });
    toc.hidden = false;

    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const index = headings.indexOf(entry.target);
          links.forEach((link, linkIndex) => link.classList.toggle('is-active', linkIndex === index));
        });
      },
      { rootMargin: '-15% 0px -70% 0px' }
    );
    headings.forEach((heading) => observer.observe(heading));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snip_product_dossier_info"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.pdpDossierReady) return;
    window.pdpDossierReady = true;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Accordions: animate open / close like dossier.eu
    document.addEventListener('click', (event) => {
      const summary = event.target.closest('.pdp-dossier-accordion > details > summary');
      if (!summary) return;
      const details = summary.parentElement;
      if (details.classList.contains('is-opening') || details.classList.contains('is-closing')) {
        event.preventDefault();
        return;
      }

      if (details.open) {
        summary.setAttribute('aria-expanded', 'false');
        if (reducedMotion.matches) return;
        event.preventDefault();
        details.classList.add('is-closing');
        setTimeout(() => {
          details.open = false;
          details.classList.remove('is-closing');
        }, 300);
      } else {
        summary.setAttribute('aria-expanded', 'true');
        if (reducedMotion.matches) return;
        details.classList.add('is-opening');
        setTimeout(() => details.classList.remove('is-opening'), 360);
      }
    });

    // Size choice (only rendered for products with more than one variant)
    document.addEventListener('change', (event) => {
      const input = event.target.closest('.pdp-dossier__variant input[name="id"]');
      if (!input) return;
      const root = input.closest('.pdp-dossier');
      const dataEl = root && root.querySelector('[data-dossier-variants]');
      if (!dataEl) return;

      const data = JSON.parse(dataEl.textContent);
      const variant = data.variants[input.value];
      if (!variant) return;

      const price = root.querySelector('[data-dossier-price]');
      if (price) price.innerHTML = variant.priceHtml;

      const size = root.querySelector('[data-dossier-size]');
      if (size && variant.size) size.textContent = variant.size;

      const button = root.querySelector('[data-dossier-atc]');
      const label = root.querySelector('[data-dossier-atc-label]');
      if (button) button.disabled = !variant.available;
      if (label) label.textContent = variant.available ? data.addToCart : data.soldOut;

      if (variant.url) window.history.replaceState({}, '', variant.url);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
